import { eventType, eventSchema } from './consts';
import { HealthEvent, EventProperties } from './interfaces';

export function mapToSnowplowEvent(eventName: string, props: EventProperties): HealthEvent {
  return {
    event: eventType,
    'snowplow-event': [
      {
        schema: eventSchema,
        data: getData(eventName, props),
      },
    ],
  };
}

function getData(eventName: string, props: EventProperties) {
  return props ? { event_name: eventName, event_properties: props } : { event_name: eventName };
}
